<script>
import appConfig from '@src/app.config'
import { trackEvent } from './utils/analytics';

export default {
  page: {
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title}` : appConfig.title
    },
  },
  async created() {
    const isAddClick = sessionStorage.getItem('isAdClick');
    if(isAddClick) {
      sessionStorage.removeItem('isAdClick');
    }
    function getQueryParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }

    const gclid = getQueryParam('gclid');
    if (gclid) {
      sessionStorage.setItem('isAdClick', 'true');

      await trackEvent('sponsored_visit', {
        event_category: 'google_ads',
      });
    }
  }
}
</script>

<template>
  <div id="app">
    <keep-alive>
      <RouterView :key="$route.fullPath" />
    </keep-alive>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';

// local fonts
@import 'assets/fonts/opensans/stylesheet.css';
@import 'assets/fonts/marselis-pro/stylesheet.css';

// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';
</style>
